import React, { FunctionComponent, useState } from 'react';
import { Presentation } from './presentation';
import type { PlanTerm } from '../../../types/companyAccount';
import type { RecommendModalProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const [minimumTerm, setMinimumTerm] = useState<PlanTerm>('year');
  const [basicTerm, setBasicTerm] = useState<PlanTerm>('year');
  const [premierTerm, setPremierTerm] = useState<PlanTerm>('year');

  const handleSetMinimumTerm = (term: PlanTerm) => {
    setMinimumTerm(term);
  };

  const handleSetBasicTerm = (term: PlanTerm) => {
    setBasicTerm(term);
  };

  const handleSetPremierTerm = (term: PlanTerm) => {
    setPremierTerm(term);
  };

  return (
    <Presentation
      {...props}
      minimumTerm={minimumTerm}
      basicTerm={basicTerm}
      premierTerm={premierTerm}
      setMinimumTerm={handleSetMinimumTerm}
      setBasicTerm={handleSetBasicTerm}
      setPremierTerm={handleSetPremierTerm}
    />
  );
};
